import axios from 'axios';
import { saveAs } from 'file-saver';

import { logoutUser } from './auth';

import { UNAUTH_USER, LOADED} from './types'

// export const API_URL = 'https://api.ikostogether.com/api';
// export const CLIENT_ROOT_URL = 'https://ikostogether.com';

//localhost
let API_URL;
let CLIENT_ROOT_URL;


if (process.env.KMS_SERVER_IP) {
    API_URL = `https://${process.env.KMS_SERVER_IP}/api`;
    CLIENT_ROOT_URL = `https://${process.env.KMS_SERVER_IP}`;
} else {
    const config = require('../IPConfig.json');
    API_URL = config.API_URL;
    CLIENT_ROOT_URL = config.CLIENT_ROOT_URL;
}

export { API_URL, CLIENT_ROOT_URL };

//vm
// export const API_URL = 'http://10.107.0.5:30028/api';
// export const CLIENT_ROOT_URL = 'http://10.107.0.5:3000';


export function getData(action, errorType, isAuthReq, url, dispatch) {


  const requestUrl =`${API_URL}${url}`;

  let config = {};

  if (isAuthReq) {
    config = { headers: {
      Authorization : localStorage.getItem('token')
    }}

  }

  axios.get(requestUrl, config)
  .then((response) => {
    dispatch({
      type: action,
      payload: response.data,
    });
    dispatch({
      type: LOADED,
    });
  })
  .catch((error) => {
    errorHandler(dispatch, error.response, errorType);
  });
}


export function extractFile(action, errorType, isAuthReq, url, dispatch) {

    const requestUrl = `${API_URL}${url}`;

  let config = { headers : {}, responseType:'blob'};

  if (isAuthReq) {
    config.headers.Authorization = localStorage.getItem('token')
  }

  axios.get(requestUrl, config)
  .then((response) => {

    let reader = new FileReader();
    let blob = new Blob([response.data]);
    reader.readAsDataURL(blob);
    if (response.data.type==="image/jpeg"){
      saveAs(blob,"document.jpeg")
    }else if (response.data.type==="application/pdf"){
      saveAs(blob,"document.pdf")
    }else if (response.data.type==="image/png"){
      saveAs(blob,"document.png")
    }else if (response.data.type==="image/jpg"){
      saveAs(blob,"document.jpg")
    }else if (response.headers['content-disposition']){
      const filename = response.headers['content-disposition'].substring(22,response.headers['content-disposition'].length-1)
      saveAs(blob,filename)
    }else{
      console.log("do nothing")
    }
    dispatch({
      type: action,
      payload: response.data,
    });
    dispatch({
      type: LOADED,
    });
  })
  .catch((error) => {
    errorHandler(dispatch, error.response, errorType);
  });
}

export function getFile(action, errorType, isAuthReq, url, dispatch) {

    const requestUrl = `${API_URL}${url}`;

  let config = { headers : {}, responseType:'blob'};

  if (isAuthReq) {
    config.headers.Authorization = localStorage.getItem('token')
  }

  axios.get(requestUrl, config)
  .then((response) => {
    dispatch({
      type: action,
      payload: response.data,
    });
    dispatch({
      type: LOADED,
    });
  })
  .catch((error) => {
    errorHandler(dispatch, error.response, errorType);
  });
}

// Post Files Request
export function postFiles(action, errorType, isAuthReq, url, dispatch, data) {
  const endpoint = localStorage.getItem('endpoint') ? localStorage.getItem('endpoint') : "";
  const requestUrl = endpoint === 'ikos' ? `${API_URL}${url}`: `${API_URL}/${endpoint}${url}`;

  let headers = {};

  if (isAuthReq) {
    headers = { headers: {
      Authorization : localStorage.getItem('token'),
      'Content-Type' : 'multipart/form-data'
      }
    };
  }

  axios.post(requestUrl, data, headers)
  .then((response) => {
    dispatch({
      type: action,
      payload: response.data,
    });
  })
  .catch((error) => {
    errorHandler(dispatch, error.response, errorType);
  });
}

// Post Request
export function postData(action, errorType, isAuthReq, url, dispatch, data) {
    const requestUrl = `${API_URL}${url}`;

  let headers = {};

  if (isAuthReq) {
    headers = { headers: { Authorization: localStorage.getItem('token') } };
  }

  axios.post(requestUrl, data, headers)
  .then((response) => {
    dispatch({
      type: action,
      payload: response.data,
    });
  })
  .catch((error) => {
    errorHandler(dispatch, error.response, errorType);
  });
}

// Put Request
export function putData(action, errorType, isAuthReq, url, dispatch, data) {
    const requestUrl = `${API_URL}${url}`;
  let headers = {};

  if (isAuthReq) {
    headers = { headers: { Authorization: localStorage.getItem('token') } };
  }

  axios.put(requestUrl, data, headers)
  .then((response) => {
    dispatch({
      type: action,
      payload: response.data,
    });
  })
  .catch((error) => {
    errorHandler(dispatch, error.response, errorType);
  });
}

// Delete Request
export function deleteData(action, errorType, isAuthReq, url, dispatch) {
    const requestUrl = `${API_URL}${url}`;
  let headers = {};

  if (isAuthReq) {
    headers = { headers: { Authorization: localStorage.getItem('token') } };
  }

  axios.delete(requestUrl, headers)
  .then((response) => {
    dispatch({
      type: action,
      payload: response.data,
    });
  })
  .catch((error) => {
    errorHandler(dispatch, error.response, errorType);
  });
}

export function errorHandler(dispatch, error, type) {

  let errorMessage = error  ? error.data.error : error;
  dispatch({
    type: LOADED,
  });
   // NOT AUTHENTICATED ERROR
  if (error.status === 401) {
    errorMessage = 'Les identifiants inscrits ne sont pas corrects ';
    return dispatch(logoutUser(errorMessage, UNAUTH_USER));
  }


  dispatch({
    type: type,
    payload: errorMessage,
  });

}